import { ModelStore } from 'ng2-app/modules/shared/stores/model.store';
import { Activity } from 'ng2-app/modules/activity/models/activity/activity.model';
import { ActivityService } from 'ng2-app/modules/activity/models/activity/activity.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ActivityStore extends ModelStore<Activity> {
    constructor(activityService: ActivityService) {
        super(activityService);
    }
}
